var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMesViewed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53272 7.52876C1.79379 7.26841 2.21708 7.26841 2.47815 7.52876L5.15225 10.1954C5.41332 10.4558 5.41332 10.8779 5.15225 11.1382C4.89117 11.3986 4.46789 11.3986 4.20681 11.1382L1.53272 8.47157C1.27165 8.21122 1.27165 7.78911 1.53272 7.52876Z",
    fill: "#1DC7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21241 8.19526C6.47348 7.93491 6.89677 7.93491 7.15784 8.19526L9.16341 10.1953C9.42448 10.4556 9.42448 10.8777 9.16341 11.1381C8.90234 11.3984 8.47905 11.3984 8.21798 11.1381L6.21241 9.13807C5.95133 8.87772 5.95133 8.45561 6.21241 8.19526Z",
    fill: "#1DC7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5007 4.86177C10.7617 5.12212 10.7617 5.54423 10.5007 5.80457L5.15247 11.1379C4.8914 11.3983 4.46811 11.3983 4.20704 11.1379C3.94596 10.8776 3.94596 10.4554 4.20704 10.1951L9.55522 4.86177C9.8163 4.60142 10.2396 4.60142 10.5007 4.86177Z",
    fill: "#1DC7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5119 4.86177C14.773 5.12212 14.773 5.54423 14.5119 5.80457L9.1637 11.1379C8.90263 11.3983 8.47934 11.3983 8.21827 11.1379C7.95719 10.8776 7.95719 10.4554 8.21827 10.1951L13.5665 4.86177C13.8275 4.60142 14.2508 4.60142 14.5119 4.86177Z",
    fill: "#1DC7FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesViewed);
export default __webpack_public_path__ + "static/media/mesViewed.1b7e56522d694fa2d879516a8a5c31ef.svg";
export { ForwardRef as ReactComponent };